<template>
    <confirm-modal
        title="Delete company"
        :value="value"
        confirm-button="Delete"
        cancel-button="Cancel"
        @cancel="cancel"
        @confirm="confirm"
    >
        <p>The selected company will be deleted. Would you like to confirm?</p>
        <v-list>
            <v-list-item dense>
                <v-list-item-content>
                    {{ company.company_name }}
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </confirm-modal>
</template>

<script>
    import ConfirmModal from './confirm-modal';

    export default {
        name: 'DeleteCompany',
        components: {ConfirmModal},
        props: ['value', 'company'],
        methods: {
            confirm() {
                this.$emit('confirm', this.company);
                this.$emit('input', false);
            },

            cancel() {
                this.$emit('input', false);
            },
        }
    };
</script>

<style scoped>

</style>
